module.exports = __webpack_public_path__ + "static/media/manage_deck.e3430c0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/manage_deck.jpg
// module id = 269
// module chunks = 0